import { type UserPermission as GQLItem, PermissionKeyEnum, PermissionLevelEnum } from '../../../generated/api.graphql';

export const PermissionKey = Object.freeze({
  ...PermissionKeyEnum,
} as const);
export type PermissionKey = (typeof PermissionKey)[keyof typeof PermissionKey];

export const PermissionLevel = Object.freeze({
  ...PermissionLevelEnum,
} as const);
export type PermissionLevel = (typeof PermissionLevel)[keyof typeof PermissionLevel];

export type UserPermission = {
  key: PermissionKey;
  level: PermissionLevel;
};

export const fromGql = (item: GQLItem): UserPermission => ({
  key: item.key as PermissionKey,
  level: item.level as PermissionLevel,
});

export const fromGqlCollection = (items: GQLItem[]): UserPermission[] => items.map(fromGql);
